<template>
  <v-data-table
    :headers="getHeaders"
    :items="
      hideNoConversion === true
        ? getItems.filter(
            x => x.data !== null && x.data.use_conversion_formula === true
          )
        : getItems.filter(x => x.data !== null)
    "
    :search.sync="getSearchModel"
    :loading="loading"
    :page.sync="getPageModel"
    sort-by="nom"
    :sort-desc="false"
    item-key="id"
    :mobile-breakpoint="0"
    :hide-default-header="$vuetify.breakpoint.xsOnly"
    hide-default-footer
    :items-per-page="$vuetify.breakpoint.xsOnly ? 6 : 10"
    @page-count="pageCount = $event"
    :custom-filter="customFilter"
  >
    <template v-slot:item.nom="{ item }">
      <span class="font-capitalize font-weight-bold grey--text text--darken-2">
        {{ item.nom }}</span
      >
    </template>
    <template v-slot:item.unit="{ item }">
      <v-row align="end" no-gutters>
        <span class="subtitle-1"> {{ getRecipeInventoryQty(item) }}</span>
        <span class="ml-1 caption"> {{ getRecipeUnit(item) }}</span>
      </v-row>
    </template>
    <template v-slot:item.weigth="{ item }">
      <v-row align="end" no-gutters>
        <span class="subtitle-1"> {{ getRecipeProductionQty(item) }}</span>
        <span class="ml-1 caption"> {{ getRecipeProductionUnit(item) }}</span>
      </v-row>
    </template>
    <template v-slot:item.comments="{ item }">
      <span class="subtitle-1"> {{ getRecipeComments(item) }}</span>
    </template>
    <template v-slot:item.nom="{ item }">
      <span class="font-capitalize font-weight-bold grey--text text--darken-2">
        {{ item.nom }}</span
      >
    </template>
    <template v-slot:item.actions="{ item }">
      <v-row v-if="getIsAdmin === true" align="center" justify="end" no-gutters>
        <RecipeInventoryEditorDialog
          :recipeId="item.id"
        ></RecipeInventoryEditorDialog>
      </v-row>
    </template>
    <template v-slot:item.mobile="{ item }">
      <div class="my-1">
        <v-row align="center" justify="start" no-gutters>
          <span
            class="font-capitalize font-weight-bold grey--text text--darken-2"
          >
            {{ item.nom }}</span
          >
        </v-row>
        <v-row align="end" no-gutters>
          <span class="font-weight-bold overline mr-3">Inventaire</span>
          <span class="subtitle-1"> {{ getRecipeInventoryQty(item) }}</span>
          <span class="ml-1 caption"> {{ getRecipeUnit(item) }}</span>
        </v-row>
        <v-row
          align="end"
          no-gutters
          v-if="getRecipeInventoryMode(item) === true"
        >
          <span class="font-weight-bold overline mr-3">Poids ou Volume</span>
          <span class="subtitle-1"> {{ getRecipeProductionQty(item) }}</span>
          <span class="ml-1 caption"> {{ getRecipeProductionUnit(item) }}</span>
        </v-row>
        <v-row
          align="center"
          v-if="
            getRecipeComments(item) !== '' && getRecipeComments(item) !== null
          "
          no-gutters
          style="flex-wrap: nowrap;"
        >
          <span class="font-weight-bold overline mr-3">Détails</span>
          <span class="subtitle-1"> {{ getRecipeComments(item) }}</span>
        </v-row>
      </div>
    </template>
    <template v-slot:top>
      <v-row align="center" justify="space-between">
        <v-col>
          <v-tooltip right>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                small
                icon
                text
                :color="hideNoConversion === true ? 'success' : ''"
                @click="hideNoConversion = !hideNoConversion"
              >
                <v-icon small>fa-balance-scale-left</v-icon>
              </v-btn>
            </template>
            <span v-if="hideNoConversion === true"
              >Afficher toutes les recettes</span
            >
            <span v-else>Cacher les recettes sans conversions</span>
          </v-tooltip>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="10" sm="6">
          <v-text-field
            dense
            filled
            hide-details
            single-line
            clearable
            prepend-inner-icon="fa-search"
            v-model="getSearchModel"
            class="no-before"
          ></v-text-field>
        </v-col>
      </v-row>
    </template>
    <template v-slot:footer>
      <v-pagination
        color="accent"
        v-model="getPageModel"
        :length="pageCount"
        :total-visible="5"
      ></v-pagination>
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters } from "vuex";
import RecipeInventoryEditorDialog from "./RecipeInventoryEditorDialog";
export default {
  name: "RecipeUnitGrid",
  components: {
    RecipeInventoryEditorDialog
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    finalRecipe: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["getOrganisationId", "getIsAdmin"]),
    getProducts() {
      return this.$store.getters.getProducts.filter(
        x => x.organisation === this.getOrganisationId
      );
    },
    getHeaders() {
      if (this.$vuetify.breakpoint.xsOnly) {
        return [
          { value: "mobile", text: "" },
          { value: "actions", text: "", width: 50 }
        ];
      } else {
        return [
          { value: "nom", text: "Nom" },
          { value: "unit", text: "Unité d'inventaire" },
          { value: "weigth", text: "Poids ou Volume" },
          { value: "comments", text: "Indications additionnelles" },
          { value: "actions", text: "", width: 175 }
        ];
      }
    },
    getPageModel: {
      get() {
        return this.$store.getters.getRecipePage;
      },
      set(v) {
        this.$store.commit("setRecipePage", v);
      }
    },
    getSearchModel: {
      get() {
        return this.$store.getters.getRecipeSearch;
      },
      set(v) {
        this.$store.commit("setRecipeSearch", v);
      }
    },

    getItems() {
      return this.finalRecipe
        ? this.items.filter(x => x.est_intermediaire === false)
        : this.items.filter(x => x.est_intermediaire === true);
    }
  },
  data() {
    return {
      hideNoConversion: false
    };
  },
  methods: {
    getRecipeUnit(item) {
      if (item.data) {
        if (item.data.use_conversion_formula === true) {
          return item.data.unite_inventory;
        } else {
          return item.unite_produite;
        }
      } else {
        return "";
      }
    },
    getRecipeInventoryQty(item) {
      if (item.data) {
        if (item.data.use_conversion_formula === true) {
          return item.data.quantity_inventory;
        } else {
          return item.quantite_produite;
        }
      } else {
        return "";
      }
    },
    getRecipeComments(item) {
      if (item.data) {
        if (item.data.use_conversion_formula === true) {
          return item.data.comments_inventory;
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
    getRecipeProductionQty(item) {
      if (item.data) {
        if (item.data.use_conversion_formula === true) {
          return item.data.quantity_production;
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
    getRecipeProductionUnit(item) {
      if (item.data) {
        if (item.data.use_conversion_formula === true) {
          return item.unite_produite;
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
    getRecipeInventoryMode(item) {
      if (item.data) {
        return item.data.use_conversion_formula;
      } else {
        return false;
      }
    },
    customFilter(value, search, item) {
      if (search !== null) {
        const normalizeSearch = search
          .toLowerCase()
          .replace(/\s/g, "")
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "");
        const itemName = item.nom
          .toLowerCase()
          .replace(/\s/g, "")
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "");

        if (itemName.indexOf(normalizeSearch) !== -1) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    }
  }
};
</script>

<style></style>
